/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_TitleInputs */

const cs_documents_title = /** @type {(inputs: Documents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumenty`)
};

const en_documents_title = /** @type {(inputs: Documents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Documents_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_title = /** @type {((inputs?: Documents_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_title(inputs)
	return cs_documents_title(inputs)
});